module.exports = __webpack_public_path__ + "img/resource-projecti.60b168d3.svg";